enum ProcessTypeEnum 
{
    None,
    OnRoute,
    PickedUp,
    InTransit,
    OutForDelivery,
    Delivered
};

export default ProcessTypeEnum;